module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "calibre1"
  }, [_c('p', {
    staticClass: "calibre29"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('div', {
    staticClass: "calibre30",
    attrs: {
      "id": "calibre_pb_0"
    }
  }), _c('h1', {
    staticClass: "calibre31",
    attrs: {
      "id": "calibre_pb_1"
    }
  }, [_c('a', {
    staticClass: "calibre11",
    attrs: {
      "id": "_Toc86788982"
    }
  }, [_c('span', {
    staticClass: "calibre32"
  }, [_vm._v("Chapter One")])])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre29"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“You the hired hand goin’ to Mud Springs?” a tall, broad-shoulder man called through the darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“Yes, sir,” I said, hurrying down the boardwalk.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Julesburg, a town usually bustling with people, was dark and eerily quiet this morning. No one was up at such an early hour other than the two of us.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“You’re late.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“I’m sorry sir. I wasn’t sure what time….”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The man waved a hand. “Never mind. Jus’ get in.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Grabbing the wet, metal seat rail, I swung up, dropping onto the hard, wooden bench beside him.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“Name’s Hammond,” the driver said, reaching under the seat to pull out an oil cloth much like the one he was wearing. “Put this on.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("With a jolt that took me by surprise, we took off. Drenched from the quarter mile walk into town, I didn’t really see the need for an oilcloth but went ahead and draped it over my head and shoulders anyway.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("For a while, we rode in silence, the wind and the rain making it hard to talk. I was relieved, glad not to have to answer any awkward questions just yet. Leaning back on the seat, I tried to relax, snuggling my carpetbag closer against my chest to keep it dry. It didn’t contain much, just a few clothes, my bowie knife, and Ma’s Bible. It was the only memento I had of the woman who had brought me into this world, and I didn’t want it to get ruined by the rain.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("After a bit, the rain clouds moved out and the wind died down to a breeze. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“Best to set these to dry,” Mr. Hammond said, taking off his oil cloth then draping it across the wagon bed.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I nodded, spreading my oil cloth next to his. I hadn’t slept well so I was having a hard time staying awake. A thunderstorm had rolled in last night, just as I was dozing off. Big fat raindrops beat down hard on the barn roof, as though some giant were knocking, wanting to come in. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Once the storm had moved on, I’d drifted off, my sleep troubled by nightmares. I dreamt I was stuck knee-deep in mud, struggling to free myself, yet sinking deeper and deeper. In my dream, Pa stood over me yelling, “Yer good fer nothin’, Billy. Good for nothin’.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I’d awoken, scared and shaken, uncertain what time it was. With Mr. Brigg’s rooster off hiding somewhere because of the storm and no clock to check the time, I’d decided to get up and walk the quarter mile into town. Now I was glad I did because it was later than I’d thought, and I’d nearly missed my ride.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The rhythmic clip-clop of the horses’ hooves and the creaking of the wagon gradually lulled me to sleep. My head drooped forward. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre12"
  }, [_vm._v("A-woooo. A-woooo.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("My eyes snapped open. “W… what’s … that?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Reaching under the seat, Mr. Hammond pulled out a double-barreled shotgun. “Wolves.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I shivered. “Have…. Have ya ever needed to use that?” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("He pulled back the hammer, setting the rifle across his lap. “Not yet, but I been told the wolves in these parts are bigger’n mules with teeth the size of arrowheads. Out here’s no place to be caught without a weapon.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The mares faltered in their stride, muscles taut, ears pricked backwards as a second bloodcurdling howl carried up into the night. A chorus of chilling cries joined in, echoing through the darkness.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“Easy, girls,” Mr. Hammond murmured, his voice dropping an octave, his words measured and slow. “We gonna be jus’ fine.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Head high, nostrils wide, the mares kept moving, their pace choppy as the wolves continued to call back and forth. The wolves’ feral, deep-throated cries swelled to a loud, visceral chorus until a hair-raising scream ripped through the night. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("An eerie silence followed, hovering over the land like a dark cloud.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I was shaking so much. My boots beat a rapid staccato against the dash. ")]), _c('span', {
    staticClass: "calibre12"
  }, [_vm._v("Tap, tap, tap. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“You okay, boy?”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“Y… yea,” I stammered, licking my lips. I could taste the bile in my throat.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“Them wolves can be scarry sometimes,” Mr. Hammond muttered, tucking his rifle under the seat. “You’ll get used to ‘em.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I didn’t answer but kept my doubts to myself. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The rose tint of dawn finally drove back the dark, menacing night, bringing with it a sense of relief. In every direction, vast expanses of prairie stretched as far as the eye could see.  Trees were scarce, leaving the grassland and the creatures who lived here exposed to predators and fierce weather.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“See them tracks?” Mr. Hammond said, pointing to twin ruts in the ground.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I nodded. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“They’s been made by all them wagons headin’ west. People followin’ a dream.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Then he pointed to a mound of rocks marked with a simple cross of twigs tied together with a piece of string. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“There’s the grave of some poor soul who didn’t make it. It’s a rough journey. Too many times it’s the little ones who are lost along the way.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I wrapped my arms around my chest as his words struck me. I wasn’t much different from these people who had chosen to give up their homesteads, their families, their friends, and most of their belongings, just to chase a dream, hoping for a better life.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("The sun climbed higher in the sky, balmy and pleasant. I set my bag under the seat then took off my coat, draping it over the side of the wagon.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“So, what’s your name?” Mr. Hammond asked, fishing out a tobacco pouch from his pocket. ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I slid off my boots, propping my wet feet on top of the dash to dry. “Billy,” I said, turning sideways on the hard bench to see him better.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Mr. Hammond gave me a hard look as he loosened the drawstring. “Now don’t ya go tellin’ anyone. I signed the Pony Express oath good as the next man; no drinkin’, smokin’, chewin’ tabacca’, cursin’ or fightin’. But a man’s gotta do somethin’ to pass the time.”")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("Dipping his thumb and index finger into the pouch, he removed a pinch of tobacco, then wedged it in one cheek.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("“So, what made ya sign up to work at Mud Springs?” he asked, switching the wad of tobacco from one cheek to the other.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I thought about the past couple of weeks. How much could I tell this stranger?  He seemed like a nice man, yet I had to watch what I said. I couldn’t let anyone know who I really was, nor anything about my past. I had too many secrets I needed to keep safe. My life depended on it.")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  }, [_vm._v("I replied. “I didn’t.” ")])]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre4"
  }, [_c('span', {
    staticClass: "calibre5"
  })]), _vm._v(" "), _c('p', {
    staticClass: "calibre22"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54010ed0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/part0005.vue
// module id = 75
// module chunks = 0